import { Skeleton } from '@/components/ui'

/** Table-shaped placeholder: a header row + N body rows of M columns. */
export function TableSkeleton({ rows = 6, cols = 5 }: { rows?: number; cols?: number }) {
  return (
    <div className="overflow-hidden rounded-card ring-1 ring-zinc-950/5">
      <div className="flex gap-4 border-b border-zinc-950/5 bg-zinc-50 px-4 py-3.5">
        {Array.from({ length: cols }).map((_, i) => (
          <Skeleton key={i} className="h-3 flex-1" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-4 border-b border-zinc-950/5 px-4 py-4 last:border-0">
          {Array.from({ length: cols }).map((_, i) => (
            <Skeleton key={i} className="h-3 flex-1" />
          ))}
        </div>
      ))}
    </div>
  )
}

/** Grid of stat-card placeholders. */
export function StatsSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="rounded-card bg-surface p-6 shadow-sm ring-1 ring-zinc-950/5">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="mt-3 h-8 w-32" />
        </div>
      ))}
    </div>
  )
}

/** Generic card placeholder with a title line + body lines. */
export function CardSkeleton({ lines = 4 }: { lines?: number }) {
  return (
    <div className="rounded-card bg-surface p-6 shadow-sm ring-1 ring-zinc-950/5">
      <Skeleton className="h-4 w-40" />
      <div className="mt-4 flex flex-col gap-3">
        {Array.from({ length: lines }).map((_, i) => (
          <Skeleton key={i} className="h-3 w-full" />
        ))}
      </div>
    </div>
  )
}
